import React, { useContext, useEffect, useState } from "react";
import ChatTerminalHeader from "./views/_partials/chatTerminalHeader";
import { PdfURLProvider } from "../../../context/pdfURL/pdfURLProvider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../../context/user/userContext";
import { getSkillStoreData } from "../../mks-applications/skillStore/services/skillStoreService";
import { hasGroupAccess } from "../../../services/commonService";
import loaderContext from "../../../context/loader/loaderContext";
import showMessage from "../../common/message";


const Chat = () => {
  const { state: stateNav } = useLocation();
  const navigate = useNavigate();
  const { skillStoreId } = useParams();

  const { state } = useContext(UserContext);
  const securityGroups = state?.user?.userProfile?.msalSecurityGroup;

  const { updateLoaderStatus } = useContext(loaderContext);

  const [isValidSkill, setIsValidSkill] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSkillChat, setIsSkillChat] = useState(false);
  const [isFileType, setIsFileType] = useState(false);
  const [matchedSkill, setMatchedSkill] = useState(null);
  const [skillData, setSkillData] = useState([]);

  // useEffect(() => {
  //   if (!isMksChatEnable && !isSkillChatEnable) {
  //     navigate("/home");
  //   }
  // }, [isMksChatEnable, isSkillChatEnable, navigate]);

  useEffect(() => {
    const validateSkill = async () => {
      if (!skillStoreId) {
        setIsValidSkill(true);
        return;
      }

      try {
        updateLoaderStatus(true);
        const res = await getSkillStoreData();

        if (!res) {
          showMessage("Unable to load skills.", -2);
          setIsValidSkill(true);
          return;
        }

        setSkillData(res);
        const filteredSkills = res.filter(
          (item) => item.IsThirdPartyAITool === false
        );

        const matchedSkill = filteredSkills.find(
          (item) => String(item.Id) === String(skillStoreId)
        );

        if (!matchedSkill) {
          showMessage("Skill not found.", -2);
          setIsValidSkill(true);
          return;
        }

        const access = hasGroupAccess(
          securityGroups,
          matchedSkill.SecurityGroupId
        );

        if (!access) {
          showMessage(
            "You don't have access to " + matchedSkill.Name + " bot."
            , -2);
          setIsValidSkill(true);
          return;
        }

        const uiView =
          matchedSkill?.ChatbotConfiguration?.ChatbotUIView?.toLowerCase() ||
          "";
        const isFile =
          matchedSkill?.ChatbotConfiguration?.InputType?.toLowerCase() === "file"
            ? true
            : false;

        const derivedIsAdditives = uiView === "additives";

        setIsSkillChat(
          stateNav?.isAdditivesFound ?? derivedIsAdditives
        );

        setIsFileType(
          stateNav?.isFileType ?? isFile
        );
        setMatchedSkill(matchedSkill);
        setIsValidSkill(true);
      } catch (error) {
        console.error(error);
        setErrorMessage("Something went wrong.");
      } finally {
        updateLoaderStatus(false);
      }
    };

    validateSkill();
  }, [skillStoreId, securityGroups]);

  if (errorMessage) {
    return (
      <div className="chat-terminal-wrapper">
        <div className="chat-box-wrapper">
          <div className="error-message">{errorMessage}</div>
        </div>
      </div>
    );
  }

  if (!isValidSkill) {
    return null;
  }

  return (
    <PdfURLProvider>
      <div className="chat-terminal-wrapper">
        <div className="chat-box-wrapper">
          <ChatTerminalHeader
            isMKSChatSelected={
              stateNav === null ? true : stateNav?.isMKSChat
            }
            chatMessage={stateNav?.chatMessage}
            skillStoreId={skillStoreId}
            setIsSkillChat={setIsSkillChat}
            setIsFileType={setIsFileType}
            isFileType={isFileType}
            isSkillChat={isSkillChat}
            matchedSkill={matchedSkill}
            skillData={skillData}
          />
        </div>
      </div>
    </PdfURLProvider>
  );
};

export default Chat;
